//@ts-nocheck
import React from "react";
import { SlateEditor, SlateToolbar, SlateContent } from "slate-editor";
import { BoldPlugin, BoldButton } from "@slate-editor/bold-plugin";
import { ItalicPlugin, ItalicButton } from "@slate-editor/italic-plugin";
import {
    UnderlinePlugin,
    UnderlineButton,
} from "@slate-editor/underline-plugin";
import {
    StrikethroughPlugin,
    StrikethroughButton,
} from "@slate-editor/strikethrough-plugin";
import {
    AlignmentPlugin,
    AlignmentButtonBar,
} from "@slate-editor/alignment-plugin";
import { LinkPlugin, LinkButton } from "@slate-editor/link-plugin";
import { ListPlugin, ListButtonBar } from "@slate-editor/list-plugin";
import {
    FontFamilyPlugin,
    FontFamilyDropdown,
} from "@slate-editor/font-family-plugin";
import { FontSizePlugin, FontSizeInput } from "@slate-editor/font-size-plugin";
import { ImagePlugin, ImageButton } from "@slate-editor/image-plugin";
import {
    ColorPlugin,
    ColorButton,
    ColorStateModel,
} from "@slate-editor/color-plugin";
import { GridPlugin, GridButtonBar } from "@slate-editor/grid-plugin";
import { EmbedPlugin, EmbedButton } from "@slate-editor/embed-plugin";
import { StateLoggerButton } from "@slate-editor/state-logger";
import { ToggleReadOnlyButton } from "@slate-editor/toggle-readonly";

import "components/Editor/Editor.css";

const fontSizePluginOptions = { initialFontSize: 16 };
const colorPluginOptions = new ColorStateModel()
    .rgba({ r: 100, g: 100, b: 100, a: 1 })
    .gen();

const plugins = [
    AlignmentPlugin(),
    BoldPlugin(),
    ColorPlugin(),
    EmbedPlugin(),
    FontFamilyPlugin(),
    FontSizePlugin(fontSizePluginOptions),
    GridPlugin(),
    ImagePlugin(),
    ItalicPlugin(),
    LinkPlugin(),
    ListPlugin(),
    StrikethroughPlugin(),
    UnderlinePlugin(),
];

const classNames = {
    button: "btn m-0 rounded-0 bg-white text-light",
    dropdown: "select col-3  mx1 not-rounded",
    input: "input col-3  mr1",
    slateToolbar: "bg-white",
};
const styles = {
    dropdown: {
        position: "relative",
        backgroundColor: "white",
        height: 38,
        paddingLeft: 20,
        border: "none",
        margin: "0",
        WebkitAppearance: "none",
        padding: "0 10px 0 15px",
    },
    input: {
        position: "relative",
        backgroundColor: "white",
        borderRadius: 0,
        height: 38,
        margin: 0,
        color: "#0275d8",
        border: "none",
    },
    content: {
        boxShadow:
            "0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02)",
        border: "none",
    },
};

const Editor = () => {
    return (
        <div className="page--home">
            <SlateEditor plugins={plugins}>
                <SlateToolbar className={classNames.slateToolbar}>
                    <BoldButton className={classNames.button} />
                    <ItalicButton className={classNames.button} />
                    <UnderlineButton className={classNames.button} />
                    <StrikethroughButton className={classNames.button} />
                    <AlignmentButtonBar className={classNames.button} />
                    <LinkButton className={classNames.button} />
                    <ListButtonBar className={classNames.button} />
                    <FontFamilyDropdown
                        className={classNames.dropdown}
                        style={styles.dropdown}
                    />
                    <FontSizeInput
                        {...fontSizePluginOptions}
                        className={classNames.input}
                        style={styles.input}
                    />
                    <ImageButton
                        className={classNames.button}
                        signingUrl={
                            process.env.REACT_APP_API_URL +
                            process.env.REACT_APP_SIGNING_URL_ENDPOINT
                        }
                    />
                    <ColorButton
                        className={classNames.button}
                        initialState={colorPluginOptions}
                        pickerDefaultPosition={{ x: -520, y: 17 }}
                    />
                    <GridButtonBar className={classNames.button} />
                    <EmbedButton className={classNames.button} />
                </SlateToolbar>
                <SlateContent wrapperStyle={styles.content} />
            </SlateEditor>
        </div>
    );
};

export default Editor;
